<section
    class="flex flex-col rounded-2xl border-4 border-surface-chat-A bg-surface-A p-6"
>
    <button
        class="flex items-center rounded-lg bg-surface-B"
        type="button"
        (click)="attachmentClicked.emit()"
    >
        <interacta-attachment-preview [attachment]="attachment" />
        <section class="flex grow flex-col items-start overflow-hidden p-8">
            <interacta-inner-ellipses-text
                class="max-w-full typo-sm-bold text-text"
                [matTooltip]="attachment.name"
                [text]="attachment.name"
            />
            <p class="typo-sm text-nowrap text-ellipsis text-text">
                {{ attachment.creatorUser?.fullName }}
            </p>
            @if (attachment.creationTimestamp) {
                <interacta-creation-date
                    class="typo-sm text-text-mid-contrast"
                    [date]="attachment.creationTimestamp"
                />
            }
        </section>
    </button>
    @if (showThreadButton) {
        <button
            class="mt-8 flex items-center gap-x-4"
            type="button"
            (click)="goToThread.emit()"
        >
            <span class="typo-sm text-text"
                >{{
                    (messagesCount === 1
                        ? 'AI.MESSAGES_IN_THREAD_SING'
                        : 'AI.MESSAGES_IN_THREAD_PLUR'
                    ) | translate: { count: messagesCount }
                }}
            </span>
            <interacta-icon class="size-24" [icon]="'chevron-small-right'" />
            @if (hasErrors) {
                <interacta-icon
                    class="ml-auto size-24 text-text-error"
                    [attr.aria-label]="'AI.ERROR_THREAD' | translate"
                    [icon]="'warning'"
                    [matTooltip]="'AI.ERROR_THREAD' | translate"
                />
            }
        </button>
    }
</section>
